export default "__VITE_PUBLIC_ASSET__e51b538f__"